<template>
  <div class="upload_">
    <p>请上传公司介绍PDF：（如需重新上传，请先移除已选择文件。）</p>
    <a-select placeholder="请选择公司名称" v-model="name" style="width:300px;margin-right:30px;" @change="companyChange" show-search :filter-option="filterReferCode" dropdownClassName="auto-scroll">
        <a-select-option
                v-for="(item, index) in companyName"
                :key="index+'-name'"
                :value="item.content"
                >{{ item.content}}</a-select-option>
    </a-select>
    <a-select placeholder="请选择上传类型" v-model="type" style="width:300px;margin-right:30px;margin-bottom:20px;" show-search :filter-option="filterReferCode" dropdownClassName="auto-scroll">
        <a-select-option
                v-for="(item, index) in uploadType"
                :key="index+'-type'"
                :value="item.code"
                >{{ item.content}}</a-select-option>
    </a-select><br>
     <a-upload :file-list="fileList" :remove="handleRemove" :before-upload="beforeUpload" accept=".pdf" >
      <a-button> <a-icon type="upload" /> 选择PDF </a-button>
    </a-upload>
    <a-button
      type="primary"
      :disabled="fileList.length===0"
      :loading="uploading"
      style="margin-top: 16px"
      @click="handleUpload"
    >
      {{ uploading ? '上传中' : '开始上传' }}
    </a-button>
    <a :href="url" class="showpdf" target="_blank" v-if='uploadSuc'>预览</a>
    <p v-if='uploadSuc' style="padding:20px 0;">上传成功！</p>
  </div>
</template>

<script>

export default {
  data () {
    document.title = '上传公司PDF'
    return {
      fileList:[],
      uploading: false,
      uploadSuc:false,
      companyName:[],
      uploadType:[
      ],
       name:'',
       type:''
    }
  },
  mounted () {
    this.queryFileTypes()
  },
  methods: {
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },
    beforeUpload(file) {
      if(this.fileList.length<1){
        this.fileList = [...this.fileList, file];
      }
      return false;
    },
    queryFileTypes(){
      this.$api.queryFileTypes().then(res =>{
        // this.uploadType = res.data.content.certificates
        this.companyName = res.data.content || []
      })
    },
    companyChange(val) {
      if (! val) {
        this.uploadType = [];
        this.type = ''
      }
      for(let i = 0; i < this.companyName.length; i ++) {
        if (this.companyName[i].content === val) {
          this.uploadType = this.companyName[i].certificateTypes
          break;
        }
      }
      console.log(this.uploadType, this.name)
      const isSameType = this.uploadType.some(item => {
        return item.code === this.type
      })
      if (! isSameType) {
        this.type = ''
      }
    },
    handleUpload() {
      if(this.name!=''&&this.type!=''){
        const formData = new FormData();
        this.uploading = true
        formData.append('file', this.fileList[0]);
        let data={org:this.name,type:this.type}
        this.$api.uploadPdf(data,formData).then(res=>{
          if(res.data.returnCode==='00'){
            this.uploading = false;
            this.uploadSuc=true
            this.fileList=[]
            this.url=res.data.content
          }
        })
      }else{
        alert('请先选择公司名称和上传文件类型')
      }
    },
    filterReferCode(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
  },
};
</script>

<style lang="scss" scoped>
  .upload_{
    padding:50px;
  }
  .showpdf{
    width:88px;
    height:32px;
    line-height:32px;
    border:1px solid #fe8f2d;
    text-align:center;
    display:inline-block;
    margin-left:30px;
    border-radius:4px;
  }
</style>
<style lang="scss">
  .auto-scroll .ant-select-dropdown-menu {
      width: 100%;
      overflow: auto;
    .ant-select-dropdown-menu-item {
      overflow: unset;
    }
  }
</style>
